<div class="input-group" [class]="classDate" >
    <input [placeholder]="placeholder ?? '' | translate" [id]="id" type="text"  class="form-control">
    <button class="input-group-text" type="button">
    <i class="feather icon-calendar icon-md text-muted"></i>
  </button>
</div>